export const SENTIMENT_TOTAL = {
	'title': '',
	'xData': [],
	ySplitLineShow: false,
	ySplitAreaShow: false,
	xSplitLineShow: false,
	xSplitAreaShow: false,

	colors:['#49D26D','#EB4545'],
	legend: {
		data:[],
		left: 'center',
		top:'bottom',
		orient:'horizontal'
	},
	series: [{
		'name': '',
		'showLabel': true,
		'radius': ['40%', '60%'],
		'data': [],
		'smooth': false,
		itemStyle:{
			normal:{
				color:function(params) {
					//自定义颜色
					var colorList = [          
							'#ff8080', '#33ffad', '#33ffff',
						];
						return colorList[params.dataIndex]
					 }
			}
		}
	}]
}



// WEBPACK FOOTER //
// ./src/components/sentiment/config/sentimentTotal.js